import { EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { HIDE_DATA_SYMBOL, UNBREAKABLE_SEPARATOR } from 'constants/string';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';

export const formatWorkplaceTitle = (data: TWorkplaceFormFields, isHideData = false) => {
  const { employmentType, jobTitle } = data;
  const hasData = Boolean(employmentType?.value || jobTitle?.value);

  if (isHideData && hasData) {
    return Array(2).fill(HIDE_DATA_SYMBOL.repeat(4)).join(UNBREAKABLE_SEPARATOR);
  }

  switch (employmentType?.value) {
    case EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE:
    case EMPLOYMENT_TYPE_VALUES.RETIRED:
    case EMPLOYMENT_TYPE_VALUES.BUSINESS_OWNER: {
      return employmentType.label;
    }
    default: {
      return jobTitle?.label || AccordionHeaderParamsTexts.HeaderDefaultTitle;
    }
  }
};
